import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import '../styles/auth.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { setError('Please enter your email.'); return; }
    setError('');
    setLoading(true);
    try {
      await axios.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      setError(err?.response?.data?.message || 'Could not process the request.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <Link to="/" className="floating-back-btn">&#8592; Library</Link>

      <div className="auth-bg-ornament" aria-hidden="true">&#10040; &#10040; &#10040;</div>

      <div className="auth-card">
        <Link to="/" className="auth-logo"><img className="auth-brand-image" src="/branding/deenlit-logo.png" alt="DeenLit" width="2172" height="724" /></Link>
        <p className="auth-tagline">Reset your password</p>

        {sent ? (
          <>
            <div className="auth-success" role="status">
              If that email is registered, a reset link has been sent. It's valid for 1 hour.
            </div>
            <p className="auth-switch">
              <Link to="/login" className="auth-link auth-link-btn">Back to sign in</Link>
            </p>
          </>
        ) : (
          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            <label className="auth-field">
              <span>Email</span>
              <input
                type="email"
                name="email"
                autoComplete="email"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => { setEmail(e.target.value); if (error) setError(''); }}
                required
              />
            </label>

            {error && <div className="auth-error" role="alert">{error}</div>}

            <button type="submit" className="auth-submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send reset link'}
            </button>

            <p className="auth-switch">
              Remembered it?{' '}
              <Link to="/login" className="auth-link auth-link-btn">Sign in</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
